import axios from "axios";
import Salary from "@/classes/Salary/Salary";
import VariablePaymentType from "@/enums/VariablePaymentType";
const BASE_URL = "/admin/payments";
const getSalariedEmployees = async (year, month) => {
    const result = await axios.get(`${BASE_URL}/employees/${year}/${month}`);
    return result.data.map((salary) => new Salary(salary));
};
const getMonthtlySalaries = async (year, month) => {
    const result = await axios.get(`${BASE_URL}/monthlysalaries/${year}/${month}`);
    return result.data;
};
const putMonthtlySalaries = async (year, month, userId, payDate) => {
    const result = await axios.put(`${BASE_URL}/monthlysalaries/${year}/${month}/${userId}`, {
        expectedPaymentDate: payDate,
    }, {
        params: {
            force: true,
        },
    });
    return result.data;
};
const getYearlyBonuses = async (year) => {
    const result = await axios.get(`${BASE_URL}/yearlybonuses/${year}`);
    return result.data;
};
const putYearlyBonuses = async (year, force = true) => {
    const result = await axios.put(`${BASE_URL}/yearlybonuses/${year}`, force);
    return result.data;
};
const getSalaryAdditions = async (year, month, user) => {
    const result = await axios.get(`${BASE_URL}/${year}/${month}/${user}/details/additions`);
    return result.data;
};
const postSalaryAdditions = async (year, month, user, data) => {
    const result = await axios.post(`${BASE_URL}/details/additions/${year}/${month}/${user}`, data);
    return result.data;
};
const deleteSalaryAddition = async (userId, paymentId, additionId) => {
    const result = await axios.delete(`${BASE_URL}/details/${userId}/${paymentId}/${additionId}`);
    return result.data;
};
const getSalaryDetails = async (paymentId, paymentType) => {
    switch (paymentType) {
        case VariablePaymentType.Director:
            return await getSalaryDetailsDirector(paymentId);
        case VariablePaymentType.TeamManager:
            return await getSalaryDetailsTeamManager(paymentId);
        case VariablePaymentType.Fixed:
            return await getSalaryDetailsFixed(paymentId);
        case VariablePaymentType.Level:
            return await getSalaryDetailsLevel(paymentId);
        default:
            throw new Error("test");
    }
};
const getSalaryDetailsLevel = async (paymentId) => {
    const result = await axios.get(`${BASE_URL}/${paymentId}/details/billable/level`);
    return result.data;
};
const getSalaryDetailsDirector = async (paymentId) => {
    const result = await axios.get(`${BASE_URL}/${paymentId}/details/billable/director`);
    return result.data;
};
const getSalaryDetailsTeamManager = async (paymentId) => {
    const result = await axios.get(`${BASE_URL}/${paymentId}/details/billable/teammanager`);
    return result.data;
};
const getSalaryDetailsFixed = async (paymentId) => {
    const result = await axios.get(`${BASE_URL}/${paymentId}/details/billable/fixed`);
    return result.data;
};
export { getSalariedEmployees, getMonthtlySalaries, putMonthtlySalaries, getYearlyBonuses, putYearlyBonuses, getSalaryAdditions, postSalaryAdditions, deleteSalaryAddition, getSalaryDetails, };
